import { render, staticRenderFns } from "./DialogUtil.vue?vue&type=template&id=a4fcf032&scoped=true"
import script from "./DialogUtil.vue?vue&type=script&lang=js"
export * from "./DialogUtil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fcf032",
  null
  
)

export default component.exports